import {
  params,
  shape,
  arrayOf,
  string as stringType,
  number as numberType,
} from '@thd-nucleus/data-sources';

export const dataModel = {
  loyaltyMembershipDetails: params({
    userId: stringType().isRequired(),
    customerAccountId: stringType().isRequired(),
    channelId: numberType().isRequired(),
  }).shape({
    proTiers: shape({
      benefitTags: arrayOf(
        shape({
          tagName: stringType(),
          value: stringType(),
        }),
      ),
    }),
  }),
  userState: params({
    userId: stringType().isRequired(),
    channelId: numberType().isRequired(),
  }).shape({
    customer: shape({
      hierarchyOrgId: stringType(),
      companyId: stringType(),
    }),
  }),
};
